import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export const ERRORS_CATEGORY = 'Errors';
export const ADDRESS_NOT_CREATED = 'Address not created';
export const NO_BILLING_ADDRESS = 'no billing';
export const NO_SHIPPING_ADDRESS = 'no shipping';

export class SignupToCheckoutTransitionApplicationEventModel implements ApplicationEvent {

  type = ApplicationEventType.SignUpToCheckoutTransition;

  constructor(private category: string, private action: string, private label: string) {
  }

  getPayload(): any {
    return {
      category: this.category,
      action: this.action,
      label: this.label
    };
  }
}
